import { render, staticRenderFns } from "./MentorsSection.vue?vue&type=template&id=5dfb5d2f&"
import script from "./MentorsSection.vue?vue&type=script&lang=js&"
export * from "./MentorsSection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports